<template>
  <div class="ifttt-overview">
    <EditIfttt :modalId="'editIftttModal'"></EditIfttt>
    <CreateIfttt :modalId="'createIftttModal'"></CreateIfttt>
    <CardView :title="$t('menu.ifttt')">
      <b-row class="mb-4 pr-3 pt-0">
        <b-col cols="1" sm="auto" class="ml-auto">
          <Button class="w-100 h-2 mb-2 mt-2 ml-3 pl-3 pr-3" @frameworkButtonClicked="createIfttt()"
            :color="getColors.defaultColorSolidButton" :backgroundColor="getColors.defaultBackgroundColorSolidButton"
            :fontSize="'15px'" :fontWeight="'600'" :outline="true" :size="'small'" :display="'inline'"
            :width="'calc(100% - 5px)'" :padding="'2px 0'">
            <template #button-content>
              <span>{{ $t('ifttt.createIfttt.createButton') }} <i class="far fa-plus"></i></span>
            </template>
          </Button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <ve-table v-if="getAutomations.length" :max-height="700" class="ifttt-table" :virtual-scroll-option="virtualScrollOption"
            width="100" :fixed-header="true" :expand-option="null" row-key-field-name="rowKey" :columns="getColumns" :scroll-width="'70vw'"
            :cellSelectionOption="cellSelectionOption" :row-style-option="rowStyleOption"
            :event-custom-option="customEventOptions" :table-data="getAutomations" />
          <div v-else>{{ $t('ifttt.table.noRecords') }}</div>
        </b-col>
      </b-row>
    </CardView>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {customEventOptions} from "@/mixins/vueEasyTable/bodyCellEvents";

import colors from "@/assets/scss/MotivateColors.scss";
import Button from "@/components/ui/Button.vue";

import CardView from "@/components/cardView.vue";
import EditIfttt from "@/components/ifttt/EditIfttt.vue";
import CreateIfttt from "@/components/ifttt/CreateIfttt.vue";

export default {
  name: "iftttOverview",
  components: {Button, CreateIfttt, EditIfttt, CardView},
  data() {
    return {
      cellSelectionOption: {
        enable: false,
      },
      virtualScrollOption: {
        enable: true,
      },
      rowStyleOption: {
        stripe: true,
        clickHighlight: true,
        hoverHighlight: true,
      }
    }
  },
  mixins: [customEventOptions],
  computed: {
    ...mapGetters('ifttt', ['getAutomations']),
    getColumns() {
      return [
        {
          field: "name",
          key: '1',
          title: this.$t('ifttt.name'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (<div class="automation-name-cell">
              <div class="automation-name">{row.name}</div>
            </div>);
          }
        },
        {
          field: "actions",
          key: '5',
          title: this.$t('ifttt.table.columns.actions'),
          align: "left",
          functions: [
            {id: 'delete-ifttt-button', handler: this.deleteIfttt},
            {id: 'edit-ifttt-button', handler: this.editIfttt}
          ],
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (<div class="row">
                  <div class="col-12 col-md-6">
                    <button tag="edit-ifttt-button" class="framework-text-button-primary">{this.$t('ui.edit')}</button>
                  </div>
                  <div class="col-12 col-md-6">
                    <i tag="delete-ifttt-button" class="framework-text-button-primary far fa-trash delete"></i>
                  </div>
                </div>
            )
          }
        }
      ]
    },
    getColors() {
      return colors
    },
  },
  methods: {
    async editIfttt($event) {
      window.$('#editIftttModal').data('parameters', {iftttId: $event.row.id});
      window.$('#editIftttModal').modal('show');
    },
    async createIfttt($event) {
      window.$('#createIftttModal').modal('show');
    },
    async deleteIfttt($event) {
      const deleteSwal = await this.$swal({
        title: this.$t("ifttt.delete.swal.title"),
        html: this.$t("ifttt.delete.swal.text", {name: $event.row.name}),
        icon: 'error',
        customClass: 'm-swal-delete',
        confirmButtonText: this.$t("ifttt.delete.swal.confirm"),
        showCancelButton: true,
        cancelButtonText: this.$t('ui.cancel'),
        reverseButtons: true
      });
      if (deleteSwal.value) {
        await this.$store.dispatch('ifttt/delete', $event.row.id);
        this.$toasted.global.successRequest(this.$t("ifttt.delete.toast.success"))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/desktop/ve-table-desktop.scss";
@import "@/assets/scss/components/desktop/frameworkButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkTextButtonDesktop.scss";
@import "@/assets/scss/components/desktop/frameworkModalDesktop.scss";

@import "../../assets/scss/MotivateColors";
@import "@/assets/scss/workflowInterface/form.scss";
</style>